/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum ShoppingCartDiscountTypeEnum {
    AMOUNT_FOR_SHOPPING_CART_PART = 'AMOUNT_FOR_SHOPPING_CART_PART',
    PERCENTAGE_FOR_SHOPPING_CART_PART = 'PERCENTAGE_FOR_SHOPPING_CART_PART',
}